module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('EmployeeFilter', {
    staticClass: "row",
    attrs: {
      "fields": ['area', 'project', 'username']
    },
    on: {
      "params": function (params) { return _vm.queryParams = params; },
      "filteredUsers": function (users) { return _vm.refresh(users.map(function (user) { return user.login; })); }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 m-b-30 label-style top-header-row"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_vm._v("\n                    Bieżący tydzień jest "), _c('b', [_vm._v(_vm._s(_vm.currentWeekParity === 0 ? 'parzysty' : 'nieparzysty'))]), _vm._v(" - (\n                    "), _c('span', {
    staticClass: "adjust-plan",
    on: {
      "click": function($event) {
        _vm.adjustPlan = !_vm.adjustPlan
      }
    }
  }, [(_vm.adjustPlan) ? _c('span', [_vm._v(" Wyświetl cały plan")]) : _c('span', [_vm._v(" Wyświetl plan tylko na ten tydzień")])]), _vm._v(" )\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "color-legend"
  }, _vm._l((_vm.places), function(place) {
    return _c('div', {
      style: ('background-color:' + _vm.getPlaceColor(place.id))
    }, [_vm._v("\n                        " + _vm._s(place.name) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "box-bordered p-l-10 p-r-10"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table text-align-c table-pp"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("pracownik")]), _vm._v(" "), _vm._l((_vm.weekdays), function(weekday, weekdayId) {
    return _c('th', {
      class: {
        'highlight-today': _vm.currentDow === weekdayId
      }
    }, [_vm._v(_vm._s(weekday) + "\n                        ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.planGrouped), function(plan, emp) {
    return _c('tr', {
      key: emp
    }, [_c('td', {
      staticClass: "right-border-column"
    }, [_c('div', {
      class: {
        'half-time-hours-warning': !_vm.halfTimeHoursMet(plan)
      }
    }, [_vm._v("\n                                " + _vm._s(emp)), (!_vm.halfTimeHoursMet(plan)) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.numberOfPlacesChosen(plan) > 0) ? _c('div', {
      staticClass: "container"
    }, [_c('hr'), _vm._v(" "), _vm._l((_vm.weekHours(plan)), function(time, place) {
      return _c('div', {
        staticClass: "week-hours-places",
        style: ({
          'background-color': _vm.getPlaceColor(place),
          padding: '3px'
        })
      }, [_vm._v("\n                                    " + _vm._s(_vm.weekMinutesFormatted(time.current)) + "\n                                    "), (time.current !== time.next && time.next !== 0) ? _c('span', [_vm._v("\n                                                | " + _vm._s(_vm.weekMinutesFormatted(time.next)))]) : _vm._e()])
    }), _vm._v(" "), (_vm.numberOfPlacesChosen(plan) !== 1) ? _c('strong', [_vm._v(_vm._s(_vm.hoursSumWeekParity(plan)))]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _vm._l((plan), function(dowGroup, dowId) {
      return _c('td', [_vm._l((dowGroup), function(dowPlan) {
        return (!_vm.adjustPlan || _vm.matchingCurrentWeekId(dowPlan.week_id)) ? _c('WorktimeEditableHour', {
          attrs: {
            "plan": dowPlan,
            "places": _vm.places,
            "editable": _vm.editable(emp),
            "color": _vm.getPlaceColor(dowPlan.place)
          },
          on: {
            "updated": _vm.updateUpdated,
            "deleted": _vm.updateDeleted
          }
        }) : _vm._e()
      }), _vm._v(" "), (_vm.editable(emp)) ? _c('div', [_c('div', {
        staticClass: "btn btn-link",
        attrs: {
          "data-toggle": "modal",
          "data-target": '#' + _vm.getAddModalId(dowId)
        }
      }, [_vm._v("\n                                    +\n                                ")]), _vm._v(" "), _c('WorktimeFormModal', {
        attrs: {
          "modalId": _vm.getAddModalId(dowId),
          "dow": dowId + 1,
          "fromTimeValueDefault": '09:00',
          "toTimeValueDefault": '17:00',
          "places": _vm.places
        },
        on: {
          "created": _vm.updateCreated
        }
      })], 1) : _vm._e()], 2)
    })], 2)
  }), 0)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.allHalfTimeHoursMet),
      expression: "!allHalfTimeHoursMet"
    }]
  }, [_c('div', {
    staticClass: "half-time-hours-warning"
  }, [_vm._v("\n                * Plan pracy obejmuje mniej niż 20 godzin!\n            ")])])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c790d92!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/WorktimePlan.vue
// module id = 1092
// module chunks = 0